/* global Sys, Core */
Sys.ns("Core");

/**
 * The G4 module.
 *
 * Handling the G4 feature.
 *
 * @class Core.G4
 * @extends Core.Module
 */
Core.G4 = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.G4.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            model: Core.G4Model,
            view: Core.View,
            controller: Core.G4Controller
        };
    },

    /**
     * @protected
     * @inheritdoc
     */
    getStateChanges: function() {
        var model = this.model;

        return {
            minimumRoundTimeEnforcement: {
                state: {
                    name: "MinimumRoundTimeEnforcement",
                    execute: function(env) {
                        // stub
                    },
                    waitEvents: {
                        "notify:g4.minimumRoundTimePassed": false
                    }
                }
            },
            stopped: {
                queue: [
                    function(env) {
                        if (model.isEnforcementRequired() && model.isNewRound()) {
                            env.stateHandler.pushState(env.states.minimumRoundTimeEnforcement);
                        }
                    }
                ]
            }
        };
    }
};

Core.G4 = Sys.extend(Core.Module, Core.G4, "Core.G4");
